type NotificationType = 'BDA_APP_STATUS_CHANGE' | 'BDA_APP_ASSET_CREATED';
type TriggerType = 'NOTIFICATION_TYPE' | 'ADVANCED';

interface EmailPreferences {
  enabled: boolean;
  address: string;
}
interface FeedPreferences {
  emails: EmailPreferences;
}
interface ApplicationWebPreferences {
  enabled: boolean;
  monitoringMode: string;
  specificApplications: number[];
}

interface NotificationWebPreferences {
  enabled: boolean;
  applications: ApplicationWebPreferences;
}
export interface NotificationPreferences {
  created: string;
  feedPreferences: FeedPreferences;
  id?: number;
  notificationTypes: NotificationType[];
  organizationId: string;
  updated: string;
  userId: string;
  webPreferences: NotificationWebPreferences;
  enabled: boolean;
}
export interface AppNotification {
  details: any;
  executorId: string;
  id: number;
  organizationId: string;
  read: boolean;
  timestamp: string;
  type: NotificationType;
}

interface KeyValuePair {
  key: string;
  value: string;
}

export class NotificationTrigger {
  id?: number;
  name: string;
  url: string;
  method?: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  body: any;
  headers: KeyValuePair[];
  queryParams: KeyValuePair[];
  type?: TriggerType;
  notificationType?: NotificationType;
  bdaId?: string;
  serviceId?: string;
  assetKey?: string;

  constructor() {
    this.name = "";
    this.url = "";
    this.body = null;
    this.headers = [];
    this.queryParams = [];
  }
}